import React from 'react';
import { PageProps, Link } from 'gatsby';
import { AppItemProps } from '../../types';
import { GatsbyImage } from 'gatsby-plugin-image';
import ArrowIcon from '@/images/svgs/arrow.svg';

const AppItem: React.FC<PageProps<AppItemProps>> = ({ data }) => {
  return (
    <div className="group/app-item flex flex-col">
      <img
        src={data.logo.publicURL}
        alt={data.altLogo}
        className="mx-auto mb-[1.5rem] max-w-[20.375rem]"
      />
      <GatsbyImage
        image={data.cover}
        alt={data.altCover}
        className="w-full object-cover object-top border border-primary h-[37rem]"
      />
      <p
        data-test-id="app-item-excerpt"
        className="my-[1.5rem] mx-8 text-xl flow-1"
      >
        {data.excerpt}
      </p>
      <Link
        to={data.goTo}
        className="text-primary flex items-center text-xl mt-auto self-end"
      >
        <span className="inline-block transition-all duration-500 mr-4 hover:font-bold">
          See more
        </span>
        <ArrowIcon className="inline-block" />
      </Link>
    </div>
  );
};

export default AppItem;
